export default "__VITE_ASSET__DBw7PU$2__"